module.exports = __webpack_public_path__ + "static/media/styles.c7d468de.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/gdc-components-atoms-heading/styles.scss
// module id = 480
// module chunks = 0